import { render, staticRenderFns } from "./scroll-to-top.component.vue?vue&type=template&id=6b76f7d2&scoped=true&"
import script from "./scroll-to-top.component.vue?vue&type=script&lang=ts&"
export * from "./scroll-to-top.component.vue?vue&type=script&lang=ts&"
import style0 from "./scroll-to-top.component.vue?vue&type=style&index=0&id=6b76f7d2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76f7d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
